var _switch;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    requiredExtensions: "http://ns.adobe.com/AdobeIllustrator/10.0/",
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M57.9 54.8c0.5 0 1-0.3 1.4-0.7l6.3-8.5 5.2 3.9c0.4 0.3 0.8 0.4 1.3 0.3 0.4-0.1 0.8-0.3 1.1-0.7l6.3-8.4 1.7 1.3c0.4 0.3 0.9 0.3 1.3 0.1 0.4-0.2 0.7-0.6 0.7-1.1l0.3-6.9c0-0.4-0.2-0.8-0.5-1.1 -0.3-0.2-0.8-0.3-1.1-0.2l-6.5 2.2c-0.4 0.2-0.8 0.5-0.8 1 -0.1 0.5 0.1 0.9 0.5 1.2l1.8 1.3 -5.3 7.1 -5.2-3.9c-0.4-0.3-0.8-0.4-1.3-0.3 -0.4 0.1-0.8 0.3-1.1 0.7l-7.3 9.8c-0.6 0.7-0.4 1.8 0.3 2.4C57.1 54.7 57.5 54.8 57.9 54.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3 67H62c0.6 0 1.2-0.5 1.2-1.2v-6.6c0-0.6-0.5-1.2-1.2-1.2h-4.7c-0.6 0-1.2 0.5-1.2 1.2v6.6C56.2 66.5 56.7 67 57.3 67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5 53.4h-4.7c-0.6 0-1.2 0.5-1.2 1.2v11.3c0 0.6 0.5 1.2 1.2 1.2h4.7c0.6 0 1.2-0.5 1.2-1.2V54.6C73.7 53.9 73.2 53.4 72.5 53.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4 48.7c-0.6 0-1.2 0.5-1.2 1.2v15.9c0 0.6 0.5 1.2 1.2 1.2h4.7c0.6 0 1.2-0.5 1.2-1.2V49.9c0-0.6-0.5-1.2-1.2-1.2H78.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7 20.4h-47c-2.1 0-3.8 1.7-3.8 3.8v51.6c0 2.1 1.7 3.8 3.8 3.8h47c2.1 0 3.8-1.7 3.8-3.8V24.2C97.5 22.1 95.8 20.4 93.7 20.4zM91.7 73.8h-43V26.2h43V73.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2 20.7H5.4c-1.6 0-2.9 1.3-2.9 2.9 0 1.6 1.3 2.9 2.9 2.9h26.8c1.6 0 2.9-1.3 2.9-2.9C35.1 22 33.8 20.7 32.2 20.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2 34H5.4c-1.6 0-2.9 1.3-2.9 2.9s1.3 2.9 2.9 2.9h26.8c1.6 0 2.9-1.3 2.9-2.9S33.8 34 32.2 34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2 47.3H5.4c-1.6 0-2.9 1.3-2.9 2.9 0 1.6 1.3 2.9 2.9 2.9h26.8c1.6 0 2.9-1.3 2.9-2.9C35.1 48.6 33.8 47.3 32.2 47.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2 60.5H5.4c-1.6 0-2.9 1.3-2.9 2.9s1.3 2.9 2.9 2.9h26.8c1.6 0 2.9-1.3 2.9-2.9S33.8 60.5 32.2 60.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2 73.8H5.4c-1.6 0-2.9 1.3-2.9 2.9 0 1.6 1.3 2.9 2.9 2.9h26.8c1.6 0 2.9-1.3 2.9-2.9C35.1 75.1 33.8 73.8 32.2 73.8z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStock);
export default __webpack_public_path__ + "static/media/stock.0f96a65f.svg";
export { ForwardRef as ReactComponent };